// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3skKW","productName":"Table_productName__32xId"};